import type { ComponentProps } from 'react'
import type { MetaAd } from '@storefronts/common-types'
import { HoverCardContent, HoverCardPortal } from '@/components/ui/hover-card'
import { AdVideoEmbed, getMetaVideoEmbedSrc } from './AdVideoEmbed'
import { getMetaAdBestImageUrl, getMetaAdVideoUrl } from './metaAdCreativeUtils'

interface AdCreativeHoverContentProps
    extends Pick<ComponentProps<typeof HoverCardContent>, 'side' | 'align'> {
    name: string
    videoUrl?: string | null
    imageUrl?: string | null
}

export function AdCreativeHoverContent({
    name,
    videoUrl,
    imageUrl,
    side,
    align,
}: AdCreativeHoverContentProps) {
    const embedSrc = videoUrl ? getMetaVideoEmbedSrc(videoUrl) : null

    if (videoUrl && embedSrc) {
        return (
            <HoverCardPortal>
                <HoverCardContent
                    side={side}
                    align={align}
                    className="w-auto border-0 p-0 shadow-xl"
                >
                    <AdVideoEmbed mediaUrl={videoUrl} name={name} />
                </HoverCardContent>
            </HoverCardPortal>
        )
    }

    if (imageUrl) {
        return (
            <HoverCardPortal>
                <HoverCardContent
                    side={side}
                    align={align}
                    className="w-80 border-0 p-0 shadow-xl"
                >
                    {/* eslint-disable-next-line @next/next/no-img-element */}
                    <img
                        src={imageUrl}
                        alt={name}
                        className="max-h-96 w-full object-contain bg-muted"
                    />
                </HoverCardContent>
            </HoverCardPortal>
        )
    }

    return null
}

interface MetaAdCreativeHoverContentProps {
    ad: MetaAd
}

export function MetaAdCreativeHoverContent({
    ad,
}: MetaAdCreativeHoverContentProps) {
    return (
        <AdCreativeHoverContent
            name={ad.name}
            videoUrl={getMetaAdVideoUrl(ad)}
            imageUrl={getMetaAdBestImageUrl(ad)}
        />
    )
}
